























































































import { Vue, Component } from 'vue-property-decorator';
import { Tab, Tabs } from 'vant';
// tab页面组件

Vue.use(Tab).use(Tabs);
@Component({
  components: {},
})
export default class Introduction extends Vue {}
